const specialDestinationPostalCodes = ["35", "38", "51", "52", "AD"];
const specialProfile = "CFRIO-DEST_ESPECIAL";

export const checkSpecialDestination = (postalCode) => {
  if (!postalCode) return false;

  const prefix = postalCode.toString().substring(0, 2).toUpperCase();

  return specialDestinationPostalCodes.includes(prefix);
};

export const checkAuthorisedPostalCode = (userProfiles, postalCode) => {
  let canUseSpecialDestination = false;
  let isSpecialDestination = checkSpecialDestination(postalCode);

  if (!postalCode) {
    console.error("No se ha proporcionado código postal.");
    return false;
  }

  if (!isSpecialDestination) {
    return true;
  }

  if (checkSpecialDestination(postalCode)) {
    for (let profile of userProfiles) {
      if (profile?.profileCod === specialProfile) {
        canUseSpecialDestination = true;
      }
    }
  }

  return canUseSpecialDestination;
};

// Comprobamos si el código postal es extrapeninsular
// si lo es, recorremos los perfiles proporcionados
// si existe un perfil DEST_ESPECIAL, devolvemos true
// si no se cumple alguna de las condiciones anteriores, devolvemos false;
